import { FC, useEffect, useState } from "react";

import { IconButton, Typography } from "@mui/material";

import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';

const StartupModuleName: string = "Admin Dashboard";

interface ModuleNameAndFavouriteProps {
    moduleName: string;
}

const ModuleNameAndFavourite: FC<ModuleNameAndFavouriteProps> = ({ moduleName }) => {
    const [isFavourite, setIsFavourite] = useState<boolean>(false);

    useEffect(() => {
        const favourites: string[] = JSON.parse(localStorage.getItem('favouriteModules') || '[]');
        setIsFavourite(favourites.includes(moduleName));
    }, [moduleName]);

    function handleFavourite() {
        const favourites: string[] = JSON.parse(localStorage.getItem('favouriteModules') || '[]');
        if (isFavourite) {
            const updatedFavourites = favourites.filter((mod: string) => mod !== moduleName);
            localStorage.setItem('favouriteModules', JSON.stringify(updatedFavourites));
            setIsFavourite(false);
        }
        else {
            favourites.push(moduleName);
            localStorage.setItem('favouriteModules', JSON.stringify(favourites));
            setIsFavourite(true);
        }
    }

    return (
        <>
            <Typography variant="h6" noWrap component="div">
                {moduleName}
            </Typography>

            {moduleName !== StartupModuleName ?
                <IconButton onClick={handleFavourite}>
                    {isFavourite ?
                        <StarIcon sx={{ color: 'gold' }} />
                        :
                        <StarBorderIcon sx={{ color: 'black' }} />}
                </IconButton>
                :
                null
            }
        </>
    );
}

export default ModuleNameAndFavourite;
